<template>
    <div class="bank-transfer-container">
        <div class="bank-transfer-container__left">
            <div class="notice accent">{{ $t('deposit by bank transfer, free of charge') | capitalize }}</div>
            <div class="notice">
                {{ $t('adding to your Superbet account is like any bank payment, from your online ' +
                    'banking account or at your bank\'s counter') | capitalize }}!
            </div>
            <SubtleLinkExternal :link="staticlink($t('metode-de-plata-transfer-bancar'))">
                {{ $t('details about bank transfer deposits') | capitalize }}
            </SubtleLinkExternal>
            <template v-if="barcodeState !== barcodeStates.renderFailed">
                <div
                    v-if="barcodeState === barcodeStates.renderedSuccessfully"
                    class="notice accent"
                >
                    {{ $t('scan with your m-banking app') | capitalize }}
                </div>
            </template>
        </div>
        <div class="bank-transfer-container__right">
            <div class="field">
                <div class="label">IBAN:</div>
                <div class="value">{{ config.app.user.deposit.bankTransferIban }}</div>
            </div>
            <div class="field">
                <div class="label">{{ $t('account name') | capitalize }}:</div>
                <div class="value">{{ config.app.user.deposit.bankTransferAccountName }}</div>
            </div>
            <div class="field-container">
                <div class="field">
                    <div class="label">{{ $t('bank') | capitalize }}:</div>
                    <div class="value">{{ config.app.user.deposit.bankTransferBank }}</div>
                </div>
                <div class="field">
                    <div class="label">SWIFT:</div>
                    <div class="value">{{ config.app.user.deposit.bankTransferSwift }}</div>
                </div>
            </div>
            <div class="field-container">
                <div class="field">
                    <div class="label">{{ $t('city') | capitalize }}:</div>
                    <div class="value">{{ config.app.user.deposit.bankTransferCity }}</div>
                </div>
                <div class="field">
                    <div class="label">{{ $t('currency') | capitalize }}:</div>
                    <div class="value">{{ config.app.user.deposit.bankTransferCurrency }}</div>
                </div>
            </div>
            <div class="field">
                <div class="label">{{ $t('payment description') | capitalize }}</div>
                <div class="value value__important">{{ user.username }}</div>
            </div>
        </div>
    </div>
</template>

<script>
    import config from '@config';
    import { capitalize, staticlink } from '@shared/filters';

    const barcodeStates = {
        uninitialized: 1,
        renderedSuccessfully: 2,
        renderFailed: 3,
    };

    export default {
        name: 'BankTransfer',
        props: {
            user: {
                type: Object,
                required: true
            },
        },
        data() {
            return {
                barcodeState: barcodeStates.uninitialized,
            };
        },
        created() {
            this.staticlink = staticlink;
            this.config = config;
            this.barcodeStates = barcodeStates;
        },
        computed: {
            barcodeText() {
                const {
                    bankTransferIban,
                    bankTransferBank,
                    bankTransferCity,
                    bankTransferCurrency,
                    bankTransferAccountName,
                    bankTransferSwift,
                } = config.app.user.deposit;

                const fields = [
                    ['IBAN', bankTransferIban],
                    ['bank', bankTransferBank],
                    ['payment description', 'axilis1'],
                    ['city', bankTransferCity],
                    ['currency', bankTransferCurrency],
                    ['account name', bankTransferAccountName],
                    ['SWIFT', bankTransferSwift]
                ];
                return fields.map(([label, value]) => `${capitalize(this.$t(label))}:${value}`)
                    .join('\n');
            }
        },
        methods: {
            onBarcodeSuccess() {
                this.barcodeState = this.barcodeStates.renderedSuccessfully;
            },
            onBarcodeError() {
                this.barcodeState = this.barcodeStates.renderFailed;
            }
        }
    };
</script>


// WEBPACK FOOTER //
// src/app/modules/userProfile/deposit/AccordionItems/BankTransfer.vue